import React from 'react';
import { ArrowRight, PhoneCall } from 'lucide-react';
import { BOOKING_URL } from '../mock';

export default function FinalCTA() {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl border border-[#0b0f0d] bg-[#0b0f0d] p-10 lg:p-16">
          <div className="absolute -top-40 -right-32 w-[500px] h-[500px] bg-[#ea580c]/25 rounded-full blur-[130px]" />
          <div className="absolute inset-0 dot-grid opacity-25" />

          <div className="relative text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/20 bg-white/5 text-white text-xs font-medium mb-6">
              <PhoneCall size={13} className="text-[#ea580c]" /> Limited to 3 new partners this month
            </div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-semibold text-white leading-[1.05]">
              Ready for <em className="italic text-[#ea580c] font-medium">30 to 50 qualified leads</em> a month?
            </h2>
            <p className="mt-5 text-white/70 text-lg">
              Grab a free 30 minute strategy session. We’ll audit your market, show you exactly what it takes to hit your revenue goal, and if we are a fit, offer you exclusivity in your city.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-white hover:bg-[#faf9f5] text-[#0b0f0d] font-semibold px-7 py-4 rounded-full">
                Book Your Free Strategy Call
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
            <div className="mt-6 text-sm text-white/50">No commitment. No pitch deck. Just a real conversation.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
